const Footer = () => {
  return <footer className="relative bg-foreground text-background pt-20 pb-8">
      {/* Curved Top Wave */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] rotate-180">
        <svg className="relative block w-full h-[80px] md:h-[120px]" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C300,100 900,100 1200,0 L1200,120 L0,120 Z" className="fill-foreground" />
        </svg>
      </div>

      {/* Footer Content */}
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Column 1 - Explore */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                
              </li>
              <li>
                
              </li>
              <li>
                
              </li>
              <li>
                <a href="/blog" className="text-background/70 hover:text-background transition-colors">
                  Blog
                </a>
              </li>
              <li>
                
              </li>
            </ul>
          </div>

          {/* Column 2 - Company */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-background/70 hover:text-background transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="mailto:ronan@macroflow.ai?subject=Career Conversation" className="text-background/70 hover:text-background transition-colors">
                  Careers
                </a>
              </li>
              <li>
                
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                
              </li>
              <li>
                <a href="mailto:ronan@macroflow.ai" className="text-background/70 hover:text-background transition-colors">
                  Email
                </a>
              </li>
              <li>
                
              </li>
              <li>
                
              </li>
              <li>
                <a href="https://linkedin.com/company/macroflow" target="_blank" rel="noopener noreferrer" className="text-background/70 hover:text-background transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/60">
            <p>© 2025 MacroFlow, LLC. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="/privacy" className="hover:text-background transition-colors">
                Privacy policy
              </a>
              <a href="/terms" className="hover:text-background transition-colors">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;